export default __webpack_public_path__ + "static/ASEAN-d460fe58baa4ca483eb844f5b589075b.png";